import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'customDate',
})
export class CustomDatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    // console.log(value);
    if (value) {
      const monthValues = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      const splitVal = value.split('T');
      const dateArray = splitVal[0].split('-');
      // console.log(dateArray);
      let formatted_date =
        dateArray[2] +
        ' ' +
        monthValues[dateArray[1] - 1] +
        ', ' +
        dateArray[0];
      return formatted_date;
    } else {
      return '';
    }
  }
}
